import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';

export const dummyAction = createAction('[SA RA] Dummy');

// #region risk Template GROUP RELATED ACTIONS
// LOAD
export const loadRaTemplate = createAction(
  '[SaRA] Load Ra Template',
  props<{ id: number }>()
);
export const loadRaTemplateSuccess = createAction(
  '[SaRA] Load Ra Template Success',
  props<{ raTemplate: any }>()
);

//#endregion

//#region likelihood REATED ACTION
//LOAD
export const loadLikelihood = createAction(
  '[SaRA] LOAD Likelihood',
  props<{ rtId: number }>()
);
export const loadLikelihoodSuccess = createAction(
  '[SaRA] LOAD Likelihood Success',
  props<{ likelihood: any }>()
);
//ADD
export const addLikelihood = createAction(
  '[SaRA] ADD Likelihood',
  props<{ likelihood: any }>()
);
export const addLikelihoodSuccess = createAction(
  '[SaRA] ADD Likelihood Success',
  props<{ likelihood: any }>()
);
//UPDATE
export const updateLikelihood = createAction(
  '[SaRA] UPDATE Likelihood',
  props<{ likelihood: any }>()
);
export const updateLikelihoodSuccess = createAction(
  '[SaRA] UPDATE Likelihood Success',
  props<{ likelihood: any }>()
);
//Delete
export const deleteLikelihood = createAction(
  '[SaRA] Delete Likelihood',
  props<{ likelihood: any }>()
);
export const deleteLikelihoodSuccess = createAction(
  '[SaRA] Delete Likelihood Success',
  props<{ likelihood: any }>()
);
//#endregion

//#region Impact Rating REATED ACTION
//LOAD
export const loadImpactRating = createAction(
  '[SaRA] LOAD ImpactRating',
  props<{ rtId: number }>()
);
export const loadImpactRatingSuccess = createAction(
  '[SaRA] LOAD ImpactRating Success',
  props<{ impactRating: any }>()
);
//ADD
export const addImpactRating = createAction(
  '[SaRA] ADD ImpactRating',
  props<{ impactRating: any }>()
);
export const addImpactRatingSuccess = createAction(
  '[SaRA] ADD ImpactRating Success',
  props<{ impactRating: any }>()
);
//UPDATE
export const updateImpactRating = createAction(
  '[SaRA] UPDATE ImpactRating',
  props<{ impactRating: any }>()
);
export const updateImpactRatingSuccess = createAction(
  '[SaRA] UPDATE ImpactRating Success',
  props<{ impactRating: any }>()
);
//Delete
export const deleteImpactRating = createAction(
  '[SaRA] Delete ImpactRating',
  props<{ impactRating: any }>()
);
export const deleteImpactRatingSuccess = createAction(
  '[SaRA] Delete ImpactRating Success',
  props<{ impactRating: any }>()
);
//#endregion

//#region Risk Rating REATED ACTION
//LOAD
export const loadRiskRating = createAction(
  '[SaRA] LOAD RiskRating',
  props<{ rtId: number }>()
);
export const loadRiskRatingSuccess = createAction(
  '[SaRA] LOAD RiskRating Success',
  props<{ riskRating: any }>()
);
//ADD
export const addRiskRating = createAction(
  '[SaRA] ADD RiskRating',
  props<{ riskRating: any }>()
);
export const addRiskRatingSuccess = createAction(
  '[SaRA] ADD RiskRating Success',
  props<{ riskRating: any }>()
);
//UPDATE
export const updateRiskRating = createAction(
  '[SaRA] UPDATE RiskRating',
  props<{ riskRating: any }>()
);
export const updateRiskRatingSuccess = createAction(
  '[SaRA] UPDATE RiskRating Success',
  props<{ riskRating: any }>()
);
//DELETE
export const deleteRiskRating = createAction(
  '[SaRA] Delete RiskRating',
  props<{ riskRating: any }>()
);
export const deleteRiskRatingSuccess = createAction(
  '[SaRA] Delete RiskRating Success',
  props<{ riskRating: any }>()
);
//#endregion

//#region Vulnerability REATED ACTION
//LOAD
export const loadVulnerabilities = createAction(
  '[SaRA] LOAD Vulnerabilities',
  props<{ rtId: number }>()
);
export const loadVulnerabilitiesSuccess = createAction(
  '[SaRA] LOAD Vulnerabilities Success',
  props<{ vulnerabilities: any }>()
);
//ADD
export const addVulnerabilities = createAction(
  '[SaRA] ADD Vulnerabilities',
  props<{ vulnerabilities: any }>()
);
export const addVulnerabilitiesSuccess = createAction(
  '[SaRA] ADD Vulnerabilities Success',
  props<{ vulnerabilities: any }>()
);
//UPDATE
export const updateVulnerabilities = createAction(
  '[SaRA] UPDATE Vulnerabilities',
  props<{ vulnerabilities: any }>()
);
export const updateVulnerabilitiesSuccess = createAction(
  '[SaRA] UPDATE Vulnerabilities Success',
  props<{ vulnerabilities: any }>()
);
//Delete
export const deleteVulnerabilities = createAction(
  '[SaRA] Delete Vulnerabilities',
  props<{ vulnerabilities: any }>()
);
export const deleteVulnerabilitiesSuccess = createAction(
  '[SaRA] Delete Vulnerabilities Success',
  props<{ vulnerabilities: any }>()
);
//#endregion

//#region Risk Velocity REATED ACTION
//LOAD
export const loadRiskVelocity = createAction(
  '[SaRA] LOAD RiskVelocity',
  props<{ rtId: number }>()
);
export const loadRiskVelocitySuccess = createAction(
  '[SaRA] LOAD RiskVelocity Success',
  props<{ riskVelocity: any }>()
);
//ADD
export const addRiskVelocity = createAction(
  '[SaRA] ADD RiskVelocity',
  props<{ riskVelocity: any }>()
);
export const addRiskVelocitySuccess = createAction(
  '[SaRA] ADD RiskVelocity Success',
  props<{ riskVelocity: any }>()
);
//UPDATE
export const updateRiskVelocity = createAction(
  '[SaRA] UPDATE RiskVelocity',
  props<{ riskVelocity: any }>()
);
export const updateRiskVelocitySuccess = createAction(
  '[SaRA] UPDATE RiskVelocity Success',
  props<{ riskVelocity: any }>()
);
//Delete
export const deleteRiskVelocity = createAction(
  '[SaRA] Delete RiskVelocity',
  props<{ riskVelocity: any }>()
);
export const deleteRiskVelocitySuccess = createAction(
  '[SaRA] Delete RiskVelocity Success',
  props<{ riskVelocity: any }>()
);
//#endregion
